require.context('.', false, /\.(png|jpe?g|svg)$/);
require.context('./partners', false, /\.(png|jpe?g|svg)$/);
require.context('./balloons', false, /\.(png|jpe?g|svg)$/);
require.context('./certificates', false, /\.(png|jpe?g|svg)$/);
require.context('./user', false, /\.(png|jpe?g|svg)$/);
require.context('./user/default_avatars', false, /\.(png|jpe?g|svg)$/);
require.context('./mails', false, /\.(png|jpe?g|svg)$/);
require.context('./payment_systems', false, /\.(png|jpe?g|svg)$/);
require.context('./proctored_icons', false, /\.(png|jpe?g|svg)$/);
require.context('./temp', false, /\.(png|jpe?g|svg)$/);